// CameraHint
// Features:
// - Displays "Left click to look around" hint
// - Visible only in cabin when pointer is NOT locked

import { usePhase, PHASES } from '../../../store/usePhase'
import { useStore } from '../../../store/useStore'
import './hint.css'

export default function CameraHint() {
    const phase = usePhase((state) => state.phase)
    const isPointerLocked = useStore((state) => state.isPointerLocked)
    const hintsHidden = useStore((state) => state.hintsHidden)
    const uiOn = useStore((state) => state.uiOn)

    // Conditions for visibility:
    // 1. UI must be globally on
    // 2. Must be inside the cabin
    // 3. Pointer must NOT be locked (if locked, you are already looking around)
    // 4. Hints must not be toggled off
    const isVisible =
        uiOn && phase === PHASES.inCabin && !isPointerLocked && !hintsHidden

    if (!isVisible) return null

    return (
        <div className="camera-hint">
            <div className="camera-hint__box">
                <div className="camera-hint__line">
                    Left click to look around
                </div>
            </div>
        </div>
    )
}
